import componentModel from './componentModel'

class configModel {
  constructor () {
    this.option = {}
    this.toast = {}
    this.notification = {}
    this.modal = {}
    this.apps = {}
  }

  /**
   * 初始化,注册组件
   * @param components 组件对象
   */
  init (_option) {
    const components = _option.components

    this.option = _option
    this.toast = _option.toast
    this.notification = _option.notification
    this.modal = _option.modal
    this.apps = _option.apps

    // 注册单元组件
    if (components && components.length > 0) {
      components.forEach(c => {
        if (c.appName)
          componentModel.registerAppComponent(c.appName, c.name, c.component)
        else
          componentModel.registerComponent(c.name, c.component)
      })
    }

    // 注册所有单元下
    if (this.apps) {
      Object.keys(this.apps).forEach(k => {
        let a = this.apps[k]
        if (a.components && a.components.length > 0) {
          a.components.forEach(c => {
            componentModel.registerAppComponent(a.name, c.name, c.component)
          })
        }
      })
    }
  }

  getToast () {
    if (this.toast)
      return this.toast
    throw ('toast组件未注册')
  }

  getNotification () {
    if (this.notification)
      return this.notification
    throw ('notification组件未注册')
  }

  getModal () {
    if (this.modal)
      return this.modal
    throw ('modal组件未注册')
  }

  getApps () {
    return this.apps
  }

  getOption () {
    return this.option
  }
}

const configInstance = new configModel

export default configInstance


// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/configModel.js